import * as React from 'react';

/**
 * Context for optional portal container (e.g. Shadow DOM root in Chrome extension).
 * When set, Radix portals (dropdowns, tooltips, etc.) render into this container
 * instead of document.body so they appear inside the same DOM tree (and get correct styles).
 */
const PortalContainerContext = React.createContext<HTMLElement | null>(null);

export function usePortalContainer(): HTMLElement | null {
  return React.useContext(PortalContainerContext);
}

export interface PortalContainerProviderProps {
  container: HTMLElement | null;
  children: React.ReactNode;
}

export const PortalContainerProvider = ({
  container,
  children,
}: PortalContainerProviderProps) => (
  <PortalContainerContext.Provider value={container}>
    {children}
  </PortalContainerContext.Provider>
);
